import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import MenuPlan from 'classes/MenuPlan/Detail/MenuPlan';
import Header from 'components/desktop/MenuPlan/CreateMenuPlanForm/Header';
import LoadingAnimation from 'components/desktop/_general/Loading/LoadingAnimation';
import clone from 'functions/clone';
import usePreferredAllergens from 'hooks/redux/usePreferredAllergens';
import { RootState } from 'reducers/rootReducer';
import { Language } from 'types/Language/Language';
import { defaultLanguage } from 'types/Language/Language';

interface IProps {
	copy?: boolean;
	id?: string;
}

const CreateMenuPlanForm = (props: IProps) => {
	const reduxCultureCode: string = useSelector((state: RootState) => state.cultureCode);
	const reduxLanguages: Language[] = useSelector((state: RootState) => state.languages);
	const reduxCurrency: string = useSelector((state: RootState) => state.currency);
	const navigate = useNavigate();
	const [menuPlan, setMenuPlan] = useState<MenuPlan>(new MenuPlan());
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [saveIsLoading, setaveIsLoading] = useState<boolean>(false);
	const [selectedLanguage, setSelectedLanguage] = useState<Language>(defaultLanguage(true));
	const preferredAllergens = usePreferredAllergens();
	const { t } = useTranslation();

	useEffect(() => {
		if (reduxCultureCode) {
			initialize();
			const language: Language | undefined = reduxLanguages.find((e: Language) => {
				return e.cultureCode === reduxCultureCode;
			});
			if (language) setSelectedLanguage(language);
		}
	}, [reduxCultureCode, props.id, preferredAllergens]);

	const initialize = async (): Promise<void> => {
		setIsLoading(true);
		try {
			await menuPlan.initialize(reduxCurrency);
			setMenuPlan(clone(menuPlan));
		} finally {
			setIsLoading(false);
		}
	};

	const handleSave = async (): Promise<void> => {
		setaveIsLoading(true);
		const response = await menuPlan.callApiPost(reduxCurrency);
		response.do((id) => {
			navigate(`/menuPlan/detail/${id}`);
		});
		setaveIsLoading(false);
	};

	return (
		<>
			<LoadingAnimation isLoading={isLoading} isModal />
			<div
				style={{
					width: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					paddingLeft: '4rem',
					paddingRight: '4rem',
				}}
			>
				<div className="row" style={{ width: '70vh', height: '60vh' }}>
					<Header
						menuPlan={menuPlan}
						setMenuPlan={setMenuPlan}
						selectedLanguage={selectedLanguage}
						setSelectedLanguage={setSelectedLanguage}
					/>
					<button
						className="btn btn-primary"
						onClick={handleSave}
						disabled={saveIsLoading}
						style={{ maxHeight: '4rem' }}
					>
						{saveIsLoading ? (
							<Spinner animation="border" size="sm" />
						) : (
							<FontAwesomeIcon icon={faCirclePlus}></FontAwesomeIcon>
						)}
						{` `}
						{t('menuPlan:CREATE_AND_START_PLANNING')}
					</button>
				</div>
			</div>
		</>
	);
};

export default CreateMenuPlanForm;
